import { getNoCatch, postNoCatch } from '@api/request';

const prefix = '/api/consultations';

export const api = {
  /**
   * 获取咨询单列表
   * 查询参数，包含分页、筛选条件等
   */
  getConsultationsList: params => getNoCatch(`${prefix}/get_consultations`, params),

  edit_consultations_item: params => postNoCatch(`${prefix}/edit_consultations_item`, params),
  back_to_ems: params => getNoCatch(`${prefix}/back_to_ems`, params),

  /**
   * 根据用户ID获取该用户的未读推送数量
   * user_id 用户ID
   */
  getPush9010Count: params => getNoCatch(`${prefix}/get_push9010_count`, params),

  /**
   * 根据用户ID查询其相关的所有推送记录
   * user_id 用户ID
   */
  getPush9010List: params => getNoCatch(`${prefix}/get_push9010`, params),

  /**
   * 更新推送记录状态（标记为已读）
   * 包含要修改的推送记录ID和用户ID等信息的对象
   */
  editPush9010: params => postNoCatch(`${prefix}/edit_push9010`, params)
};
